// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* SkillTreeViewport — fills the dashboard map slot edge-to-edge. The
   AchievementsOrb in the MapOrbTray is the toggle in/out of skill tree
   mode, so there is NO controls pill on the canvas itself. Only chrome
   is a compact bottom-anchored inspector that appears when a node is
   selected (mirrors the molecule game's minimal in-canvas chrome). */

.skill-tree-viewport {
  position: absolute;
  inset: 0;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  color: #e2e8f0;
}

/* Body fills the full slot — ProgressMap renders 1:1 with body pixel
   dimensions (no viewBox upscaling) so atoms stay at their native r=14
   regardless of how sparse the substrate is. */
.skill-tree-viewport__body {
  flex: 1 1;
  min-height: 0;
  position: relative;
}

.skill-tree-viewport__state {
  display: grid;
  height: 100%;
  place-items: center;
  color: #94a3b8;
  font-family: ui-monospace, "SF Mono", Menlo, Consolas, monospace;
  font-size: 11px;
  letter-spacing: 0.22em;
  text-transform: uppercase;
}

.skill-tree-viewport__state--error {
  color: #f87171;
  letter-spacing: 0.08em;
  text-transform: none;
}

/* The top-center selection "inspector" capsule (status / name / description /
   criteria) was RIPPED 2026-07-12 — it duplicated the node-detail float toast,
   which is now the sole node-detail surface. Its CSS lived here and is deleted. */
`, "",{"version":3,"sources":["webpack://./src/components/SkillTreeViewport/SkillTreeViewport.css"],"names":[],"mappings":"AAAA;;;;qEAIqE;;AAErE;EACE,kBAAkB;EAClB,QAAQ;EACR,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;;+CAE+C;AAC/C;EACE,SAAO;EACP,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,mBAAmB;EACnB,cAAc;EACd,gEAAgE;EAChE,eAAe;EACf,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,sBAAsB;EACtB,oBAAoB;AACtB;;AAEA;;kFAEkF","sourcesContent":["/* SkillTreeViewport — fills the dashboard map slot edge-to-edge. The\n   AchievementsOrb in the MapOrbTray is the toggle in/out of skill tree\n   mode, so there is NO controls pill on the canvas itself. Only chrome\n   is a compact bottom-anchored inspector that appears when a node is\n   selected (mirrors the molecule game's minimal in-canvas chrome). */\n\n.skill-tree-viewport {\n  position: absolute;\n  inset: 0;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n  color: #e2e8f0;\n}\n\n/* Body fills the full slot — ProgressMap renders 1:1 with body pixel\n   dimensions (no viewBox upscaling) so atoms stay at their native r=14\n   regardless of how sparse the substrate is. */\n.skill-tree-viewport__body {\n  flex: 1;\n  min-height: 0;\n  position: relative;\n}\n\n.skill-tree-viewport__state {\n  display: grid;\n  height: 100%;\n  place-items: center;\n  color: #94a3b8;\n  font-family: ui-monospace, \"SF Mono\", Menlo, Consolas, monospace;\n  font-size: 11px;\n  letter-spacing: 0.22em;\n  text-transform: uppercase;\n}\n\n.skill-tree-viewport__state--error {\n  color: #f87171;\n  letter-spacing: 0.08em;\n  text-transform: none;\n}\n\n/* The top-center selection \"inspector\" capsule (status / name / description /\n   criteria) was RIPPED 2026-07-12 — it duplicated the node-detail float toast,\n   which is now the sole node-detail surface. Its CSS lived here and is deleted. */\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
